import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

type Props = {
  to: string;
  search?: URLSearchParams;
};

const Redirect = ({ to, search }: Props): null => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  if (search) {
    search.forEach((value, key) => searchParams.append(key, value));
  }

  useEffect(() => {
    navigate(
      { pathname: to, search: searchParams.toString() },
      { replace: true }
    );
  });

  return null;
};

export default Redirect;
